import { Component, computed, inject } from '@angular/core';
import {TitleAyudaComponent} from '../../../../shared/components/title-ayuda-component/title-ayuda-component';
import { ThemeService } from '@/app/core/services/theme/theme.service';


@Component({
  selector: 'app-contacto-component',
  standalone: true,
  imports: [TitleAyudaComponent],
  templateUrl: './contacto-component.html',
  styleUrl: './contacto-component.scss',
})
export class ContactoComponent {
  private themeService = inject(ThemeService);

  pageTitle = 'Contáctanos';
  protected themeContent =  this.themeService.themeContent;
  protected contactContent = computed(() => this.themeContent()?.helpComponent?.contactSection);  


}
